import React, { memo, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import ApiService from '../../services/ApiService';
import PreLoader from "../PreLoader";
import moment from 'moment';

function WithdrawalManuallyHistory() {
    const { userId } = useSelector(state => state.auth);
    const [isLoading, setIsLoading] = useState(false);
    const [history, setHistory] = useState([]);

    const getManualWithdrawalHistory = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await new ApiService().GET(`/user-withdrawal-manual-history?user_id=${userId}`);
            if (response.data && response.data.status === "1") {
                setHistory(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching manual withdrawal history:", error);
        } finally {
            setIsLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        getManualWithdrawalHistory();
    }, [getManualWithdrawalHistory]);

    const getStatusInfo = (status) => {
        const normalized = String(status).toLowerCase();
        if (normalized === '1' || normalized === 'success' || normalized === 'paid') {
            return { label: 'PAID', color: '#8ABB45' };
        } else if (normalized === '0' || normalized === 'pending') {
            return { label: 'PENDING', color: '#ffc107' };
        } else {
            return { label: 'REJECTED', color: '#dc3545' };
        }
    };

    return (
        <>
            <PreLoader Loader={isLoading} />

            <div className="add-fund">
                <h2>Withdrawal History</h2>
                <p>Track your Zelle payouts and pending requests</p>
            </div>

            <div className="connections mt-3">
                {history.map((row, index) => {
                    const statusInfo = getStatusInfo(row.status);
                    return (
                        <div className="profile wallet-de" key={row.Id || row.id || index} style={{ borderLeft: `4px solid ${statusInfo.color}` }}>
                            <div className="details wallet-de-des" style={{ cursor: "auto" }}>
                                <h2 style={{ whiteSpace: 'nowrap' }}>Withdrawal Request #{row.code || row.Id || row.id}</h2>
                                <p className="opacity-75 mb-1">
                                    Date: {row.created_at ? moment(row.created_at).format("DD/MM/YYYY HH:mm") : 'N/A'}
                                </p>
                                <p className="opacity-75 mb-0" style={{ fontSize: '0.9rem' }}>
                                    Zelle Email: {row.zelle_email || 'N/A'}
                                </p>
                                <p className="opacity-75 mb-0" style={{ fontSize: '0.9rem' }}>
                                    Zelle Phone: {row.zelle_phone || 'N/A'}
                                </p>
                                {row.status == 1 && row.zelle_transaction_id && (
                                    <p className="text-success mt-1 mb-0" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                                        Zelle Transaction ID: {row.zelle_transaction_id}
                                    </p>
                                )}
                                {row.rejected_reason && (
                                    <p className="text-danger mt-1 mb-0" style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                                        Reason: {row.rejected_reason}
                                    </p>
                                )}
                            </div>
                            <div className="wallet-de-card text-end">
                                <h3 className="fw-bold mb-1" style={{ color: "#000" }}>
                                    ${parseFloat(row.amount || 0).toFixed(2)}
                                </h3>
                                <span className="badge p-2 fw-bold" style={{ backgroundColor: `${statusInfo.color}33`, color: statusInfo.color, borderRadius: "6px", fontSize: "0.85rem" }}>
                                    {statusInfo.label}
                                </span>
                            </div>
                        </div>
                    );
                })}

                {history.length === 0 && !isLoading && (
                    <div className="profile text-center py-5">
                        <div className="details w-100">
                            <h2 className="opacity-50">No Withdrawal Records Found!</h2>
                            <p className="opacity-40">Your manual withdrawal requests will appear here once submitted.</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default memo(WithdrawalManuallyHistory);
